import { Link } from "react-router-dom";
import { Package } from "lucide-react";

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: "sm" | "md" | "lg";
  linkTo?: string;
  tagline?: string;
}

const Logo = ({ className = "", showText = true, size = "md", linkTo = "/", tagline = "Premium Verhuisservice" }: LogoProps) => {
  const sizes = {
    sm: { container: "w-10 h-10", icon: "w-5 h-5", text: "text-lg", tagline: "text-[9px]" },
    md: { container: "w-12 h-12", icon: "w-6 h-6", text: "text-xl", tagline: "text-[10px]" },
    lg: { container: "w-16 h-16", icon: "w-8 h-8", text: "text-2xl", tagline: "text-xs" },
  };

  const currentSize = sizes[size];

  return (
    <Link to={linkTo} className={`flex items-center gap-3 group ${className}`}>
      {/* Logo Icon */}
      <div className={`${currentSize.container} rounded-xl bg-gradient-primary flex items-center justify-center shadow-lg shadow-primary/20 group-hover:shadow-primary/30 group-hover:scale-[1.02] transition-all duration-500`}>
        <Package className={`${currentSize.icon} text-primary-foreground`} />
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={`${currentSize.text} font-logo font-bold text-foreground leading-none tracking-tight`}>
            Verhuis<span className="text-primary">Match</span>
          </span>
          <span className={`${currentSize.tagline} text-muted-foreground font-medium tracking-[0.15em] uppercase mt-0.5`}>
            {tagline}
          </span>
        </div>
      )}
    </Link>
  );
};

export default Logo;